import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type StudentGroupsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function StudentGroupsToolbar({
  canManage,
  onCreate,
}: StudentGroupsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div className="flex items-center gap-2">
          <div className="">
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ກຸ່ມນັກຮຽນ
            </h2>
            <p className="text-muted-foreground">
              ຈັດການກຸ່ມນັກຮຽນເພື່ອແຍກກຸ່ມແລະຈັດ prefix ຂອງ Member ID.
            </p>
          </div>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງກຸ່ມນັກຮຽນ
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
